import React from "react";
import { Tooltip, Typography } from "antd";
import { formatAdjustmentValue, hasAdjustmentValuation, STOCK_ADJUSTMENT_COST_LABELS } from "../utils/stockAdjustmentValuation";

export default function StockAdjustmentValuation({ adjustment }) {
  const valued = hasAdjustmentValuation(adjustment);
  const source = STOCK_ADJUSTMENT_COST_LABELS[adjustment?.valuation_source];
  const date = adjustment?.valued_at ? new Date(adjustment.valued_at).toLocaleString("fr-FR") : "";
  const detail = valued
    ? `${source || "Coût enregistré"} · Coût unitaire : ${Number(adjustment.unit_cost_snapshot).toLocaleString("fr-FR", { maximumFractionDigits: 4 })} ${adjustment.valuation_currency}${date ? ` · Valorisé le ${date}` : ""}`
    : source || "Le coût de cet ancien ajustement n’a pas été historisé.";
  return <Tooltip title={detail}><Typography.Text type={valued ? undefined : "secondary"}
    aria-label={`Valeur du stock : ${formatAdjustmentValue(adjustment)}`}>
    {formatAdjustmentValue(adjustment)}
  </Typography.Text></Tooltip>;
}
